import { API } from "../config";

// services
import { APIRequest } from "./helpers/requests";

/*
 * Service functions
 */
export const sharedAccessService = {
    getSharedAccessRequests,
    releaseSharedAccess,
    createSharedAccessRequest,
    getSharedAccessRequestsStats,
    approveSharedAccess,
    denySharedAccess,
    getProviderData,
};

/* Shared Access Requests */
async function getSharedAccessRequests(params) {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS + (params || ""),
        method: "GET",
        data: {},
        private: true,
    });
}

async function getSharedAccessRequestsStats() {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS + "stats/",
        method: "GET",
        private: true,
    });
}

async function releaseSharedAccess(id, data) {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS + (id || "") + "/release/",
        method: "POST",
        data: data,
        private: true,
    });
}


async function createSharedAccessRequest(data) {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS,
        method: "POST",
        data: data,
        private: true,
    });
}

async function approveSharedAccess(id, data) {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS + (id || "") + "/approve/",
        method: "POST",
        data: data,
        private: true,
    });
}

async function denySharedAccess(id, data) {
    return await APIRequest({
        url: API.SHARED_ACCESS_REQUESTS + (id || "") + "/deny/",
        method: "POST",
        data: data,
        private: true,
    });
}

async function getProviderData(providerId) {
    return await APIRequest({
        url: `${API.BASE_URL}/users/${providerId}/`,
        method: 'GET',
        data: {},
        private: true
    });
}

